module.exports = __webpack_public_path__ + "img/ru-ru.07c3cee9.svg";